import {Box} from '@esgi/ui/layout';
import {styled} from '@esgi/ui/theme';

export const WrapperBox = styled(Box, {
	backgroundColor: '$background',
	gridArea: 'content',
	padding: 20,
});
